module.exports = __webpack_public_path__ + "static/media/buy0.a8d86979.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/buy/buy0.png
// module id = 968
// module chunks = 0